import { QRCodeSVG } from 'qrcode.react'
import { FC } from 'react'

interface QRCodeProps {
    url: string
    size?: number
}

export const QRCode: FC<QRCodeProps> = ({ url, size = 128 }) => {
    return <QRCodeSVG value={url} size={size} bgColor={'#ffffff'} fgColor={'#000000'} level={'L'} />
}
